// the items on page `page` (0-based), clamped to a real page
export function pageOf(items, page, size) {
  const pages = Math.max(1, Math.ceil(items.length / size));
  const at = Math.min(Math.max(page, 0), pages - 1);
  return { pages, at, items: items.slice(at * size, at * size + size) };
}
